import { render, staticRenderFns } from "./TestAttemptForm.vue?vue&type=template&id=028a4356&scoped=true&"
import script from "./TestAttemptForm.vue?vue&type=script&lang=js&"
export * from "./TestAttemptForm.vue?vue&type=script&lang=js&"
import style0 from "./TestAttemptForm.vue?vue&type=style&index=0&id=028a4356&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a4356",
  null
  
)

export default component.exports